import withLanguage from "../HOC/withLanguage";

const DualEducationInfo = ({ language = {} }) => {
  return (
    <div className="pb-16 text-gray-700">
      <div className="bg-gradient-to-b from-gray-200 to-white pt-16 pb-10">
        <section className="max-w-6xl mx-auto bg-white border border-gray-100 rounded-xl p-8 shadow-custom">
          <h1 className="text-4xl font-extrabold text-red-600 pb-10">{language.title}</h1>

          <div className="space-y-4">
            {language.intro?.map((paragraph, index) => (
              <p key={index} className="text-base">
                {paragraph}
              </p>
            ))}
          </div>

          <div>
            <ul className="list-disc text-sm space-y-2 pl-10 font-semibold mb-5 mt-2">
              {language.stats?.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>

          <div className="space-y-4">
            {language.studentWorkPractice?.map((paragraph, index) => (
              <p key={index} className="text-base">
                {paragraph}
              </p>
            ))}
          </div>
        </section>
      </div>
      <section className="max-w-6xl mx-auto ">
        <div className=" bg-white border border-gray-100 rounded-xl p-8 mb-8 shadow-custom">
          <h2 className="text-red-600 mb-5 text-2xl font-semibold">
            {language.legalBasis?.title}
          </h2>
          <p className="mb-5 font-semibold">{language.legalBasis?.subTitle}</p>
          <ul className="list-disc space-y-2 pl-5">
            {language.legalBasis?.items?.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>

        <div className=" bg-white border border-gray-100 rounded-xl p-8 mb-8 shadow-custom">
          <h2 className="text-red-600 mb-5 text-2xl font-semibold">{language.models?.title}</h2>
          <a
            href="/dual/Kontrate-Dual.pdf"
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-1 text-base text-blue-500 underline mb-2"
          >
            {language.models?.items[0]}
          </a>
          <a
            href="/dual/Marreveshje-Bashkepunimi-Dual.pdf"
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-1 text-base text-blue-500 underline"
          >
            {language.models?.items[1]}
          </a>

        </div>

        <div className=" bg-white border border-gray-100 rounded-xl p-8 mb-8 shadow-custom">
          <h2 className="text-red-600 mb-5 text-2xl font-semibold">
            {language.councilDecisionPurpose?.title}
          </h2>
          <p className="text-base">
            {language.councilDecisionPurpose?.description}
          </p>
        </div>

        <div className=" bg-white border border-gray-100 rounded-xl p-8 mb-8 shadow-custom">
          <h2 className="text-red-600 mb-5 text-2xl font-semibold">
            {language.employers?.title}
          </h2>
          <ul className="list-disc space-y-2 pl-5">
            {language.employers?.items?.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>

        <div className=" bg-white border border-gray-100 rounded-xl p-8 mb-8 shadow-custom">
          <h2 className="text-red-600 mb-5 text-2xl font-semibold">{language.students?.title}</h2>
          <ul className="list-disc space-y-2 pl-5">
            {language.students?.items?.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>

        <div className=" bg-white border border-gray-100 rounded-xl p-8 shadow-custom">
          <h2 className="text-red-600 mb-5 text-2xl font-semibold">
            {language.providers?.title}
          </h2>
          <ul className="list-disc space-y-2 pl-5">
            {language.providers?.items?.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      </section>
    </div>
  );
};

export default withLanguage(DualEducationInfo, "dualEducationInfo");
